import { InjectionToken } from '@angular/core';
import { ITradingProcedureService } from '../types/trading-procedure-service';

export const TRADING_PROCEDURE_SERVICE = new InjectionToken<ITradingProcedureService>('TRADING_PROCEDURE_SERVICE');
